<template>
  <div class="popup-full">
    <div class="popup-full__wrap">
      <BasePreloader v-if="pending"/>
      <button type="button"
              @click.prevent="close"
              class="popup-full__close">
        <BaseSvg name="ico-close"/>
      </button>
      <div class="popup-full__scroll">
        <div class="popup-full__content">
          <div class="popup-full__media">
            <picture class="popup-full__img">
              <img src="../../assets/img/reject-candidate.jpg"
                   :alt="$tInteraction('Reject a candidate')"
              >
            </picture>
          </div>

          <h3 class="popup-full__title">{{ $tInteraction('Reject a candidate') }}</h3>

          <div class="popup-full__reject">
            <h4 class="popup-full__reject-title">{{ $tInteraction('Enter a reason for rejection') }}</h4>
            <BaseSelect
                v-model="inputs.reject_reasons.value"
                :error="inputs.reject_reasons.error"
                :options="rejectReasons"
                text-key="name" class="popup-full__reject-select _white"/>
            <BaseInput :label="$tInteraction('Additional comment')"
                       v-model="inputs.reject_reasons_description.value"
                       textarea
                       rows="4"
                       class="popup-full__reject-input _white"
            />
          </div>

          <BaseAlert :value="overallErrorsMix"
                     class="popup-full__error  _warning"/>

          <div class="popup-full__buttons">
            <button @click="onReject"
                    type="button"
                    class="popup-full__btn  base-btn base-btn--red">
              <span>{{ $tInteraction('Deny') }}</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import {http} from '@/axios'
  import formMixins from '@/mixins/formMixins'
  import interactionStepMixin from "@/mixins/interactionStepMixin"

  export default {
    name: 'RejectCandidate',
    mixins: [formMixins, interactionStepMixin],
    props: {
      resumeId: Number,
      redirect: {
        type: [String, Object, Boolean],
        default: true,
      },
      isInteraction: Boolean,
      onRejectSuccess: Function,
      onRejectFailed: Function,
      sharedResume: {
        type: Boolean,
        default: false,
      },
    },
    data() {
      return {
        pending: false,
        inputs: {
          reject_reasons: {
            value: null,
            required: true
          },
          reject_reasons_description: {
            value: null
          }
        },
        rejectReasons: []
      }
    },
    methods: {
      close() {
        this.$vModal.close('reject-candidate')
      },
      onReject() {
        this.resetErrorsMix(this.inputs)
        const params = this.createSendDataMix(this.inputs)
        if (this.isRequiredEmptyMix) return

        if (this.sharedResume) {
          Object.assign(params, { hash: this.$route.params.sharedResumeHash })
        }

        this.pending = true;

        const url = this.isInteraction
            ? `api/new-interaction/decline/${this.resumeId}`
            : `/api/new-resume/decline/${this.resumeId}`
        return http.delete(url, {
          params
        }).then(() => {
          this.close();

          if (this.redirect) {
            const route = typeof this.redirect === 'boolean' ? { name: 'account-vacancies-responses' } : this.redirect;
            this.$router.push(route);
            return;
          }
          this.onRejectSuccess();
        }).catch(e => {
          this.errorHandlerMix(e)
          this.handleInteractionError(e, false)
        }).finally(() => {
          this.pending = false;
        });
      },
      loadReasons() {
        this.pending = true

        return http.get(`/api/helper/selectbox/resume_reject_reason`).then(({data}) => {
          this.rejectReasons = data.data
        }).catch(e => {
          this.errorHandlerMix(e)
          this.handleInteractionError(e, false)
        }).finally(() => {
          this.pending = false;
        });
      },
    },
    created() {
      this.loadReasons()
    }
  }
</script>

<style>

</style>
